import React from "react";

import "./Style/Loader.css";

const ElementLoader = (): JSX.Element => {
  return (
    <div className="wbs-element-loader-wrapper">
      <h3>Lade Daten...</h3>
      <div className="wbs-loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default ElementLoader;
